import { Card, CardContent, Grid, Stack, Typography } from '@mui/material';
import { TemplateCardPreview } from './TemplateCardPreview';
import { memo } from 'react';

export const TemplateCardItem = memo(({ template = null, isSelected = false, onClick = () => {} }) => {
  return (
    <Grid
      item
      xs={6}
    >
      <Stack
        spacing={1}
        padding={0}
      >
        <Card
          sx={{
            height: '170px',
            borderColor: 'lightgray',
            borderWidth: 1,
            borderStyle: 'solid',
            outline: (theme) => (isSelected ? `1px solid ${theme.palette.primary.main}` : 'none'),
            cursor: isSelected ? 'pointer' : 'default',
            '&:hover': {
              outline: (theme) => `1px solid ${theme.palette.primary.main}`,
              cursor: 'pointer',
            },
          }}
          onClick={() => onClick(template)}
        >
          <CardContent
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              p: 1,
              '&.MuiCardContent-root': { pb: 1 },
            }}
          >
            <TemplateCardPreview
              previewId={template?.preview_file_id}
              name={template?.name}
            />
          </CardContent>
        </Card>
        <Typography
          variant="caption"
          sx={{ textAlign: 'center' }}
        >
          {template?.name || '-'}
        </Typography>
      </Stack>
    </Grid>
  );
});

TemplateCardItem.displayName = 'TemplateCardItem';
